import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Chip, IconButton } from "@mui/material";
import { useIntl } from "react-intl";

/**
 * Edit and delete for a child row. A locked set offers neither, and says so rather than leaving the
 * cell blank. A node cell is handed the whole row, so the handlers live on the row itself.
 */
const RowActionsCell = ({ value }: { value: any }) => {
  const { formatMessage: t } = useIntl();

  if (!value?.onEdit) {
    return (
      <Box display="flex" justifyContent="flex-end">
        <Chip size="small" label={t({ id: "locked" })} />
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="flex-end">
      <IconButton size="small" aria-label={t({ id: "editLabel" })} onClick={value.onEdit}>
        <EditIcon fontSize="small" />
      </IconButton>
      <IconButton size="small" aria-label={t({ id: "deleteLabel" })} onClick={value.onDelete}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default RowActionsCell;
